<p class="section-description">
  Two independent axes: the <strong>scenario preset</strong> (input combinations driving each distinct UI variant) and
  the <strong>regen-job state</strong> (drives the polled gating overlay). Pick one of each to inspect any combination.
</p>
<div class="stacksets-scenario-controls">
  <label class="stacksets-scenario-picker">
    <span class="stacksets-scenario-picker-label">Scenario preset</span>
    <select class="arpio-select" (change)="setStacksetsScenarioPreset($any($event.target).value)">
      @for (group of stacksetsScenarioGroups; track group) {
        <optgroup [label]="group.group">
          @for (preset of group.presets; track preset) {
            <option [value]="preset.key" [selected]="preset.key === stacksetsScenarioKey">
              {{ preset.label }}
            </option>
          }
        </optgroup>
      }
    </select>
  </label>
  <p class="stacksets-scenario-description">{{ stacksetsActivePreset.description }}</p>
  <label class="stacksets-scenario-picker">
    <span class="stacksets-scenario-picker-label">Regen job state</span>
    <select class="arpio-select" (change)="setStacksetsJobScenarioByKey($any($event.target).value)">
      @for (scenario of stacksetsJobScenarios; track scenario) {
        <option [value]="scenario.key" [selected]="scenario.key === stacksetsJobScenario">
          {{ scenario.label }}
        </option>
      }
    </select>
  </label>
  @if (stacksetsJobScenarios[stacksetsJobScenarioIndex]; as scenario) {
    <p class="stacksets-scenario-description">
      {{ scenario.description }}
    </p>
  }
</div>
@if (stacksetsActivePreset.flow === 'setup') {
  <stacksets-instructions
    [arpioAccountId]="'test-account-id'"
    [regenerationJobId]="stacksetsActiveJobId"
    [migrationMode]="s_migrationMode"
    [sourceAccountId]="'111111111111'"
    [sourceRegion]="'us-east-1'"
    [targetAccountId]="'222222222222'"
    [targetRegion]="'us-west-2'"
    [sourceStackSetTemplateUrl]="'https://example.s3.amazonaws.com/source-stackset.yml'"
    [targetStackSetTemplateUrl]="'https://example.s3.amazonaws.com/target-stackset.yml'"
    [sourceTemplateBucket]="'example-bucket'"
    [sourceTemplateKey]="'source-template.yml'"
    [targetTemplateBucket]="'example-bucket'"
    [targetTemplateKey]="'target-template.yml'"
    [sourceStackName]="s_sourceStackName"
    [targetStackName]="s_targetStackName"
    [sourceManagedByStackSet]="s_sourceManagedByStackSet"
    [targetManagedByStackSet]="s_targetManagedByStackSet"
    [sourceAccessState]="s_sourceAccessState"
    [targetAccessState]="s_targetAccessState"
    [testingSource]="s_testingSource"
    [testingTarget]="s_testingTarget"
    [sourceError]="s_sourceError"
    [targetError]="s_targetError"
    [sourceTestCount]="s_sourceTestCount"
    [targetTestCount]="s_targetTestCount"
    (testAccess)="onStacksetsTestAccess($event)"
  ></stacksets-instructions>
}
@if (stacksetsActivePreset.flow === 'update') {
  <stacksets-update-instructions
    [arpioAccountId]="'test-account-id'"
    [regenerationJobId]="stacksetsActiveJobId"
    [sourceAccountId]="'111111111111'"
    [sourceRegion]="'us-east-1'"
    [targetAccountId]="'222222222222'"
    [targetRegion]="'us-west-2'"
    [sourceStackSetTemplateUrl]="'https://example.s3.amazonaws.com/source-stackset.yml'"
    [targetStackSetTemplateUrl]="'https://example.s3.amazonaws.com/target-stackset.yml'"
    [sourceManagedByStackSet]="s_sourceManagedByStackSet"
    [targetManagedByStackSet]="s_targetManagedByStackSet"
    [sourceAccessState]="s_sourceAccessState"
    [targetAccessState]="s_targetAccessState"
    [sourceTestCount]="s_sourceTestCount"
    [targetTestCount]="s_targetTestCount"
  ></stacksets-update-instructions>
}
